import { Box, Text } from '@conteg/ui';
import ForcedOpenUnitWithReservation from 'pages/storage-unit-detail/components/actions/open-unit/forced-open-unit-with-reservation';
import {
  OpenModal,
  OpenModalTypes,
} from 'pages/storage-unit-detail/components/actions/reservation-actions';
import { TwoFactorWarning } from 'pages/storage-unit-detail/components/actions/two-factor-warning';
import { useTranslation } from 'react-i18next';
import { StorageUnitListFragment } from 'types/generated/graphql';

type ActionsModalContentProps = {
  contentType: OpenModal;
  storageUnit: StorageUnitListFragment;
  onClose?: () => void;
  onDirectClose?: () => void;
};

const ActionsModalContent = ({
  contentType,
  storageUnit,
  onClose,
  onDirectClose,
}: ActionsModalContentProps) => {
  const { t } = useTranslation();

  switch (contentType) {
    case OpenModalTypes.ForcedOpenStorageUnitWithReservation:
      return (
        <>
          <TwoFactorWarning
            isTwoFactorPending={storageUnit.requiresTwoFactor}
            failedAttempts={storageUnit.twoFactorFailedAttempts}
          />
          <ForcedOpenUnitWithReservation
            storageUnitId={storageUnit.storageUnit.id}
            reservationId={storageUnit.reservationId}
            onClose={onClose}
            onDirectClose={onDirectClose}
          />
        </>
      );
  }

  if (contentType === null) return null;

  return (
    <Box textAlign="center">
      <Text
        testId="modal-content-error"
        variant="highlight"
        content={t('Page.StorageUnit.Actions.ModalError')}
      />
    </Box>
  );
};

export default ActionsModalContent;
